var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuggest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4444 0H1.55556C0.696446 0 0 0.696446 0 1.55556V12.4444C0 13.3036 0.696446 14 1.55556 14H12.4444C13.3036 14 14 13.3036 14 12.4444V1.55556C14 0.696446 13.3036 0 12.4444 0ZM10.0256 8.80444L7.27224 11.55C7.20167 11.6252 7.10314 11.6678 7.00002 11.6678C6.8969 11.6678 6.79837 11.6252 6.7278 11.55L3.97446 8.80444C3.8253 8.65059 3.8253 8.40608 3.97446 8.25222L4.1378 8.08889C4.21086 8.01847 4.30855 7.97939 4.41002 7.98H5.44446V5.05556C5.44446 4.84078 5.61857 4.66667 5.83335 4.66667H8.16669C8.38146 4.66667 8.55557 4.84078 8.55557 5.05556V7.98H9.59002C9.69149 7.97939 9.78918 8.01847 9.86224 8.08889L10.0256 8.25222C10.1747 8.40608 10.1747 8.65059 10.0256 8.80444ZM1.55557 3.11111H12.4445V1.55556H1.55557V3.11111Z",
    fill: "#05C1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggest);
export default __webpack_public_path__ + "static/media/suggest.c13ea593.svg";
export { ForwardRef as ReactComponent };